<template>
  <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      class="elevation-12"
      :hide-default-footer="true"
      dense
  >
    <template v-slot:top="scope">
      <v-data-footer
          :pagination="scope.pagination"
          :options="scope.options"
          :items-per-page-options="itemsPerPageOptions"
          items-per-page-text="Показать по"
          @update:options="scope.updateOptions"
      />
    </template>

    <template v-slot:item.createdOn="{item}">
      {{ item.createdOn.format('DD.MM.YYYY HH:mm:ss') }}
    </template>

    <template v-slot:item.actions="{item}">
      <v-btn text color="primary" :to="{name: 'web-client-registry', params: {id: item.id}}">Открыть</v-btn>
    </template>

    <template v-slot:no-data>
      Писем не найдено
    </template>
  </v-data-table>
</template>

<script>
import _ from "underscore";

export default {
  name: "RegistryDataTable",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    registries: {
      type: Array,
      default: () => {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 20,
      },
      headers: [
        {
          text: '№',
          align: 'left',
          sortable: false,
          value: 'displayNumber'
        },
        {
          text: 'Заметка',
          align: 'left',
          sortable: false,
          value: 'note'
        },
        {
          text: 'Номер реестра',
          align: 'center',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Время',
          align: 'center',
          sortable: false,
          value: 'createdOn'
        },
        {
          text: 'Всего',
          align: 'center',
          sortable: false,
          value: 'mailsCount'
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'actions'
        }
      ],
      itemsPerPageOptions: [10, 20, 50],
    };
  },
  computed: {
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    },
    items() {
      let number = 1;
      let skip = this.skip;
      return _.map(this.registries, m => {
        m.displayNumber = skip + (number++)
        return m
      })
    },
  },
  methods: {
    updateItems() {
      this.$emit("update", this.options)
    },
  },
  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    }
  }
}
</script>

<style scoped>

</style>